<template>
  <div class="summary-container">
    <div class="button-checkout">
        <p class="subtitle">Supply shipping address selections for each box in order to proceed to checkout.</p>
    </div>
    <div class="subtotal-container">
        <p class="title">Subtotal</p>
        <p class="price">{{subtotal | intToDecimalPrice}}</p>
    </div>
    <div class="item-summary" v-for="item in lineItems" :key="item.key">
        <p class="item-title">{{item.title}}</p>
        <div class="box-total">
            <div class="total-container">
                <p v-if="item.quantity > 1" class="title"><strong>({{item.quantity}})</strong> boxes</p>
                <p v-else class="title"><strong>({{item.quantity}})</strong> box</p>
                <p v-if="item.isBundle" class="price">{{(item.totalPrice/100 - ( boxPrice * item.quantity) - (feePrice * item.quantity) - (cardPrice * item.quantity)) * 100 | intToDecimalPrice}}</p>
                <p v-else class="price">{{item.totalPrice | intToDecimalPrice}}</p>
            </div>
            <p v-if="item.isBundle" class="individual-price">{{(item.individualPrice / 100 - boxPrice - feePrice - cardPrice) * 100 | intToDecimalPrice}} per box</p>
            <p v-else class="individual-price">{{item.individualPrice | intToDecimalPrice}} per box</p>
        </div>
        <div v-if="item.isBundle" class="box-total">
            <div class="total-container">
                <p class="title service-fee"><strong>({{item.quantity}})</strong> Service Fee <img v-tooltip="{content: 'This fee covers the labor to hand write your card (if applicable!) and hand pack your box beautifully!', container:false,hideOnTargetClick: false}" src="https://cdn.shopify.com/s/files/1/1363/8433/files/i_button.png?v=1589076588"/></p>
                <p class="price">{{ feePrice * item.quantity * 100 | intToDecimalPrice}}</p>
            </div>
            <p class="individual-price">{{feePrice| moneySaleFormat}} per box</p>
        </div>
        <div v-if="item.isBundle" class="box-total">
            <div class="total-container">
                <p v-if="item.quantity > 1" class="title"><strong>({{item.quantity}})</strong> Boxes</p>
                <p v-else class="title">Box</p>
                <p class="price">{{ boxPrice * item.quantity * 100 | intToDecimalPrice}}</p>
            </div>
            <p class="individual-price">{{boxPrice | moneySaleFormat}} per box</p>
        </div>
        <div v-if="item.isBundle" class="box-total">
            <div class="total-container">
                <p v-if="item.quantity > 1" class="title"><strong>({{item.quantity}})</strong> Cards</p>
                <p v-else class="title">Card</p>
                <p class="price">{{ cardPrice * item.quantity * 100 | intToDecimalPrice}}</p>
            </div>
            <p class="individual-price">{{cardPrice | moneySaleFormat}} per box</p>
        </div>
        <div class="box-total">
            <div class="total-container">
                <p class="title">Estimated Shipping</p>
                <p class="price">{{shippingPrice * item.quantity  | intToDecimalPrice}}</p>
            </div>
            <p class="individual-price">{{shippingPrice | intToDecimalPrice}} per box</p>
        </div>
        <div class="item-total">
            <p class="title">Item Total</p>
            <p class="price">{{(shippingPrice * item.quantity) + item.totalPrice  | intToDecimalPrice}}</p>
        </div>
    </div>
    <div class="taxes-container">
        <p class="title">Taxes<strong> (calculated in checkout)</strong></p>
        <p class="price">--</p>
    </div>
    <div class="shipping-term-services">
        <!-- Free standard shipping available for all domestic U.S. orders over $100, per address. If your order qualifies, the free shipping option will automatically be available to select at checkout. Orders with free standard shipping will ship via UPS Surepost. The $100 order minimum does not include taxes. If using a promo code discounts your order value to under $100, the free standard shipping option will not be available. Free shipping is only applicable for orders placed directly through <a href="/">happyboxstore.com</a>; not custom concierge orders. -->
        <!-- <br/><br/> -->
        By clicking "Continue to check out" you agree to our <a href="/pages/terms-conditions">Terms of Service</a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  components:{
  },
  data(){
    return{
        shippingPrice: 1200,
    };
  },
  props:{
    canSubmit: Boolean,
    isLoading: Boolean,
  },
  computed:{
    ...mapGetters([
      'currentCart',
      'boxProducts',
      'cardProducts',
      'feeProduct',
    ]),
    lineItems(){
        if(this.currentCart)
        {
            var lineItems = this.currentCart.items.map((x)=> {
                if(x.product_type == "GIST_BUILDER_PRODUCT"){
                    const productPrice = x.properties._gs_bundle_prices.reduce((partialSum,a) => partialSum + a,0);
                    return {title: x.properties.boxName ? x.properties.boxName : x.title,individualPrice: productPrice, totalPrice: productPrice * x.quantity,quantity:x.quantity, isBundle: true};
                }
                else {
                    return {title: x.title,individualPrice: x.final_price, totalPrice: x.final_line_price,quantity:x.quantity, isBundle: false};
                }
            })

            return lineItems;
        }

        return [];
    },
    subtotal(){
        if(this.lineItems){
            return this.lineItems.map(x => x.totalPrice).reduce((partialSum,a) => partialSum + a,0) + this.lineItems.map(x => x.quantity).reduce((partialSum,a) => partialSum + a,0) * this.shippingPrice;
        }
        return 0;
    },
    buttonText(){
        return this.isLoading ? "loading..." : "PROCEED TO CHECKOUT"
    },
    feePrice(){
        if(this.feeProduct){
            let price = (this.feeProduct.variants[0].price / 100).toFixed(2);
            return price;
        }

        return 0
    },
    boxPrice(){
        if(this.boxProducts.length > 0){
            return this.boxProducts[0].variants[0].price;
        }

        return 6
    },
    cardPrice(){
        if(this.cardProducts.length > 0){
            return this.cardProducts[0].variants[0].price;
        }

        return 6
    },
  },
  methods:{
    goToCheckout(){
        if(!this.isLoading){
            this.$emit("multishipcheckout");
        }
    }
  },
  mounted() {
  },
}
</script>

<style scoped>
    .summary-container{
        width: 33%;
        padding: 3% 2.5%;
        display: flex;
        flex-direction: column;
        align-content: center;
        background-color: #F9FAFB;
        position: sticky;
        top: 100px;
    }

    .subtitle{
        font-family: 'Karla';
        font-style: normal;
        font-weight: 400;
        font-size: 1.15vw;
        line-height: 1.4;
        color: #0F0C38;
    }

    .item-summary{
        border-top: 1px solid #D1D5DB;
        padding: 3% 0%;
    }

    .item-title{
        font-family: 'Moret';
        font-style: normal;
        font-weight: 400;
        font-size: 1.5vw;
        line-height: 1.5;
        color: #0F0C38;
        margin-bottom: 2%;
    }

    .subtotal-container,.taxes-container{
        display: flex;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        color: #0F0C38;
        font-family: 'Karla';
        font-style: normal;
        font-weight: 700;
    }

    .subtotal-container p,.taxes-container p{
        margin: unset;
    }

    .subtotal-container{
        font-size: 1.4vw;
        line-height: 1.6;
        padding-bottom: 5%;
    }

    .taxes-container{
        font-size: 1.15vw;
        line-height: 150%;
        border-top: 1px solid #D1D5DB;
        padding-top: 3%;
    }

    .taxes-container strong{
        font-weight: 400;
    }

    .box-total{
        width: 100%;
        font-weight: 400;
        font-size: 1.15vw;
        line-height: 1.4;
        color: #0F0C38;
        margin-bottom: 5%;
    }

    .box-total p,.item-total p{
        margin: unset;
    }

    .total-container{
        display: flex;
        justify-content: space-between;
    }

    .individual-price{
        font-style: italic;
    }

    .item-total{
        display: flex;
        justify-content: space-between;
        width: 100%;
        font-weight: 700;
        font-size: 1.15vw;
        line-height: 150%;
        color: #0F0C38;
    }

    .happybox-button.yellow{
        padding: 3%;
        width: 100%;
    }

    .happybox-button.yellow:disabled{
        opacity: 0.6;
    }

    .shipping-term-services {
        font-family: 'Karla',sans-serif;
        color: #0F0C38;
        font-size: 0.6rem;
        margin: 1rem 0;
    }

    .service-fee{
        display: flex;
        align-items: center;
        gap: 0.5vw;
    }

    .service-fee img{
        width: 5%;
        box-shadow: 0px 0px 4px rgb(31 ,41, 55 / 30%);
        border-radius: 20px;
    }

    .isLoading{
        animation: colorChange 2.5s ease-in-out infinite;
    }

    @keyframes colorChange {
        33% {
            background-color: #b7bfff;
        }


        66% {
            background-color: #ffc8c4;
        }

        100%{
            background-color: #ffeeda;
        }
    }

    @media screen and (max-width: 767px) {
        .summary-container{
            width: 100%;
            padding: 5%;
            margin: 3% 0%;
            position: initial;
        }

        .subtitle,.taxes-container,.box-total,.item-total{
            font-size: 3.5vw;
        }

        .item-title{
            font-size: 4.5vw;
        }

        .subtotal-container{
            font-size: 4vw;
        }

        .button-checkout{
            width: 100%;
            position: fixed;
            background-color: white;
            bottom: 0;
            left: 0;
            right: 0;
            padding: 5% 5% 2%;
            text-align: center;
        }
    }
</style>